import React from "react";
import "./Css/BookView.css";
import { useNavigate } from "react-router-dom";


const BookView = () => {
const navigate = useNavigate();
  
  return (
    <div className="invoice-page">
       <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          पुस्तक व्यवस्थापन &gt;&gt; <span>Invoice</span>
        </h3>

        <div className="edit-btnn">
    
          <button className="btn-outline">
           प्रिंट इन्व्हॉईस
          </button>
          <button
            className="btn primaryy"
          >
          डाउनलोड 
          </button>
        </div>
      </div>

      {/* Invoice Title */}
      <h2 className="title">Invoice</h2>

      {/* Invoice Meta */}
      <div className="invoice-meta">
        <p>
          <strong>Invoice ID :</strong> INV-202510252
        </p>
        <p className="status paid"> <strong>पेमेंट स्थिती :</strong> जमा</p>
      </div>

      {/* Info Cards */}
      <div className="info-gride">
        {/* Student Info */}
        <div className="info-carde">
          <h4>विद्यार्थी माहिती</h4>
          <p><span>विद्यार्थी नाव</span> : आर्या पाटील</p>
          <p><span>इयत्ता</span> : ५ वी</p>
          <p><span>मोबाईल</span> : ९८७६५४३२१०</p>
          <p><span>ईमेल</span> : aryapatil@gmail.com</p>
        </div>

        {/* Organization Info */}
        <div className="info-carde">
          <h4>संस्था माहिती</h4>
          <p><span>संस्था नाव</span> : आदर्श प्राथमिक शाळा</p>
          <p><span>संस्था पत्ता</span> : आदर्श नगर</p>
          <p><span>GST Number</span> : 27ABCDE1234F1Z5</p>
        </div>
      </div>

      {/* Book Info */}
      <div className="info-carde full-width">
        <h4>पुस्तक माहिती</h4>
        <p><span>पुस्तकाचे नाव</span> : राज्य अभ्यासक्रम इयत्ता पाचवी</p>
        <p><span>Order ID</span> : MB-210</p>
        <p><span>किंमत</span> : ₹५००</p>
        <p><span>सवलत</span> : ₹७०</p>
        <p><span>एकूण रक्कम</span> : ₹४३०</p>
        <p><span>खरेदी तारीख</span> : ०५-११-२०२५</p>
        <p><span>पेमेंट मोड</span> : UPI</p>
      </div>
    </div>
  );
};

export default BookView;
